import { Injectable } from "@angular/core";

import { PaxIcon } from "../lib";

@Injectable({
  providedIn: "root",
})
export class IconRegistryService {
  private _registry = new Map<string, string>();

  registerIcons(icons: PaxIcon[]) {
    icons.forEach((icon: PaxIcon) => this._registry.set(icon.name, icon.data));
  }

  getIcon(iconName: string) {
    const icon = this._registry.get(iconName);

    if (!icon) {
      throw new IconNotFoundException(iconName);
    }

    return icon;
  }
}

export class IconNotFoundException extends Error {
  constructor(iconName: string) {
    super(
      `The icon with the name '${iconName}' could not be found. Please ensure that you have called the 'registerIcons()' method to register the icon.`,
    );
  }
}
